import React, { useState, useEffect } from "react";
import { fetchProjectExpertFlags, FlagsStore, deleteProjectExpertFlag } from "./store";
import { format } from "date-fns";
import debounce from "debounce";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import usePagination from "../../hooks/usePagination";
import Pagination from "$components/table/components/pagination";
import Table from "$components/table/index.js";

import { LONG_DATE_FORMAT } from "$utils/date-helpers.js";

const flagColumns = [
    {
        Header: () => "Date",
        accessorKey: "flaggedDate", // accessor is the "key" in the data
        id: "flaggedDate", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ data, value }) => {
            return format(new Date(value), LONG_DATE_FORMAT);
        },
    },
    {
        Header: () => "Project Id",
        accessorKey: "projectId", // accessor is the "key" in the data
        id: "projectId", // id is used as a sort key (i.e., actual api name)
        Cell: ({ data, value }) => {
            return <a href={`/project/${data.projectKey}/potential`}>{value}</a>;
        },
        enableSorting: false,
    },
    {
        Header: () => "Flagged Employee",
        accessorKey: "flaggedEmployeeDisplayName", // accessor is the "key" in the data
        id: "flaggedEmployeeDisplayName", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
    },
    {
        Header: () => "Submitted By",
        accessorKey: "submitterDisplayName", // accessor is the "key" in the data
        id: "submitterDisplayName", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
    },
    {
        Header: () => "Reason",
        accessorKey: "reason", // accessor is the "key" in the data
        id: "reason", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
    },
    {
        Header: () => "User Feedback",
        accessorKey: "userFeedback", // accessor is the "key" in the data
        id: "userFeedback", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
    },
    {
        Header: () => "Actions",
        accessorKey: "id", // accessor is the "key" in the data
        id: "id", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
        Cell: () => {
            return (
                <div>
                    <button className="button -text">
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </div>
            );
        },
    },
];

const debouncedFetchProjectExpertFlags = debounce(fetchProjectExpertFlags, 500);

const ProjectExpertFlags = () => {
    const projectExpertFlags = FlagsStore.useState((s) => s.projectExpertFlags);
    const { page, setPage, limit, setLimit } = usePagination();

    const [expertFlagProjectId, setExpertFlagProjectId] = useState();
    const [totalPages, setTotalPages] = useState(1);
    const [sort, setSort] = useState({ id: "desc" });
    const [filters, setFilters] = useState([]);

    useEffect(() => {
        debouncedFetchProjectExpertFlags(expertFlagProjectId, page, limit);
    }, [expertFlagProjectId, page, limit]);

    useEffect(() => {
        if (projectExpertFlags && projectExpertFlags.length > 0) {
            setTotalPages(Math.ceil(projectExpertFlags[0].totalRecordCount / limit));
        }
    }, [projectExpertFlags]);

    const manualSort = (s) => {
        setSort(s);
    };

    const handleSetFilters = (data) => {
        if (data?.projectId) {
            setExpertFlagProjectId(data?.projectId);
        } else {
            if (expertFlagProjectId !== "") setExpertFlagProjectId("");
        }
        setFilters(data);
    };

    return (
        <div>
            <h1>Project Expert Flags</h1>
            <Table allowFilter={true} data={projectExpertFlags} columns={flagColumns} hiddenColumns={[]} sort={sort} setSort={manualSort} setFilters={handleSetFilters} filters={filters} showPagination={false} />
            {/*<ConfirmButton
                                onClick={() =>
                                    deleteProjectExpertFlag(flag.projectKey, flag.flaggedEmployeeId, flag.submitterUserId).then(() => {
                                        debouncedFetchProjectExpertFlags(expertFlagProjectId, page, limit);
                                    })
                                }
                                text="Delete"
                            />*/}
            <Pagination
                pageIndex={page}
                pageCount={totalPages}
                pageSize={limit}
                setPageIndex={setPage}
                setPerPage={setLimit}
                canPreviousPage={page > 1}
                canNextPage={page < totalPages - 1}
                pageOptions={Array.from({ length: totalPages }, (x, i) => i)}
            />
        </div>
    );
};

export default ProjectExpertFlags;
